export default __webpack_public_path__ + "static/media/blue-circle-dot.d7f9f6c4.svg";